<template>
    <div class="admin-page">
        <!-- Main content -->
        <div class="main-cnt">
            <div class="content-white">

                <div class="content-body">
                    <div class="box-content">
                        <div class="row h-100">
                            <div class="col-12 h-100">
                                <div class="d-flex">

                                    <!-- Add -->
                                    <button class="btn btn-pink-53 w160 mr-3" data-toggle="modal" data-target="#addDMOS">
                                        <i class="icon-plus-w mr-2"></i>
                                        {{ $t('button.add') }}
                                    </button>

                                    <!-- Edit -->
                                    <button v-if="(editObj.ids.length > 0)" class="btn btn-pink-53 w140 mr-3" data-toggle="modal" data-target="#editDMOS" data-vv-scope='s1'>
                                        <i class="icon-pencil-w mr-2"></i>
                                        {{ $t('button.edit') }}
                                    </button>

                                    <button v-else class="btn btn-gray-53 w140 mr-3">
                                        <i class="icon-pencil-w mr-2"></i>
                                        {{ $t('button.edit') }}
                                    </button>

                                    <!-- Delete -->
                                    <button v-if="(deleteObj.ids.length > 0)" class="btn btn-pink-53 w140 mr-3" data-toggle="modal" data-target="#deleteDMOS" data-vv-scope='s2'>
                                        <i class="icon-trash mr-2"></i>
                                        {{ $t('button.delete') }}
                                    </button>

                                    <button v-else class="btn btn-gray-53 w140 mr-3">
                                        <i class="icon-trash mr-2"></i>
                                        {{ $t('button.delete') }}
                                    </button>
                                </div>

                                <div class="block-cnt">

                                    <div class="loading" v-if="(loading == true)" data-vv-scope='s3'></div>

                                    <div class="table-list" v-if="(listsDMOS != null) && (loading == false)" data-vv-scope='s4'>
                                        <table class="table">
                                            <tr>
                                                <th>
                                                    <!-- <label class="checkbox-custom">
                                                        <input type="checkbox" name="selectAllDMOS" v-on:change="selectAllDMOS($event)" ref="selectAllDMOS">
                                                        <span class="checkmark"></span>
                                                    </label> -->
                                                </th>
                                                <th>{{ $t('dmos.general.connection') }}</th>
                                                <th>{{ $t('dmos.general.login_id') }}</th>
                                                <th>{{ $t('dmos.general.login_pw') }}</th>
                                                <th>{{ $t('dmos.general.period') }}</th>
                                                <th>{{ $t('dmos.general.new_accounting_flag') }}</th>
                                            </tr>

                                            <tr v-for="item in listsDMOS" :key="item.id">
                                                <td>
                                                    <label class="checkbox-custom">
                                                        <input type="checkbox" name="selectDMOS[]" v-on:change="selectDMOS($event)" :value="item.id" ref="selectDMOS">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </td>
                                                <td>{{ item.connection }}</td>
                                                <td>{{ item.login_id }}</td>
                                                <td>{{ item.login_pw }}</td>
                                                <td>{{ item.period }}</td>
                                                <td style="text-align: center;">{{ item.new_accounting_flag ? "〇" : "" }}</td>
                                            </tr>
                                        </table>
                                    </div>

                                    <div class="clearfix"></div>

                                    <div class="page-block" v-if="lastPage > 1" data-vv-scope='s5'>
                                        <paginate
                                            v-model="page"
                                            :page-count="lastPage"
                                            :page-range="3"
                                            :margin-pages="1"
                                            :click-handler="requestPagination"
                                            :prev-text="$t('pagination.prev')"
                                            :next-text="$t('pagination.next')"
                                            :class="''"
                                            :container-class="'pagination'"
                                            :page-class="'page-item'"
                                            :prev-class="'page-item'"
                                            :next-class="'page-item'"
                                            :page-link-class="'page-link'"
                                            :prev-link-class="'page-link'"
                                            :next-link-class="'page-link'">
                                        </paginate>
                                    </div>

                                    <div class="clearfix"></div>

                                    <div class="no-data" v-if="(listsDMOS == null) && (loading == false)" data-vv-scope='s6'>
                                        {{ $t('general.no_data') }}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <AddDMOSManagement
            @updateListDMOS="fetchData"
            @unSlectAllDMOS="unSlectAllDMOS">
        </AddDMOSManagement>

        <EditDMOSManagement
            :editObj='editObj'
            :dmosObj='dmosObj'
            @updateListDMOS="fetchData"
            @unSlectAllDMOS="unSlectAllDMOS">
        </EditDMOSManagement>

        <DeleteDMOSManagement
            :deleteObj='deleteObj'
            @updateListDMOS="fetchData"
            @unSlectAllDMOS="unSlectAllDMOS">
        </DeleteDMOSManagement>

    </div>
</template>

<script>
/* global $ */
import AddDMOSManagement from './Add';
import EditDMOSManagement from './Edit';
import DeleteDMOSManagement from './Delete';

import DMOSManagementService from '@/services/admin/dmos.service';
import StorageService from '@/services/common/storage.service';
import { AuthService } from '@/services/common/auth.service';

import Utils from '@/helpers/utils';
import DateUtils from '@/helpers/dateUtils';

export default {
    components: {
        AddDMOSManagement,
        EditDMOSManagement,
        DeleteDMOSManagement,
    },
    name: 'ListDMOSManagement',
    data () {
        return {
            editObj: {
                ids: [],
            },
            deleteObj: {
                ids: [],
            },

            loading: false,
            page: 1,
            lastPage: 0,
            lists: null,

            dmosObj: {
                connection: "",
                loginId: "",
                loginPw: "",
                start: "",
                end: "",
                new_accounting_flag: false,
            },
        };
    },
    beforeCreate () {
    },
    created () {
        this.fetchData();
    },
    beforeMount () {
    },
    mounted () {
    },
    computed: {
        listsDMOS: function () {
            this.$forceUpdate();
            if (this.lists && this.lists.length > 0) {
                let _list = [];
                $.each(this.lists, function (key, value) {
                    let period = "";
                    let sperator = "~";

                    if (!Utils.isEmptyStr(value.start) && !Utils.isEmptyStr(value.end)) {
                        period += DateUtils.formatDateDot(value.start) + sperator + DateUtils.formatDateDot(value.end);
                    } else {
                        if (!Utils.isEmptyStr(value.start)) {
                            period += DateUtils.formatDateDot(value.start) + sperator;
                        }
                        if (!Utils.isEmptyStr(value.end)) {
                            period += sperator + DateUtils.formatDateDot(value.end);
                        }
                    }

                    let item = {
                        id: value.id,
                        connection: value.connection,
                        login_id: value.login_id,
                        login_pw: value.login_pw,
                        start: DateUtils.formatDateDot(value.start),
                        end: DateUtils.formatDateDot(value.end),
                        period: period,
                        new_accounting_flag: value.new_accounting_flag,
                    };
                    _list.push(item);
                });
                return _list;
            } else {
                return null;
            }
        },
    },
    watch: {
        '$route' () {
            this.fetchData();
        },
    },
    methods: {
        fetchData: function fetchData () {
            this.$forceUpdate();
            this.loading = true;

            let _page = this.$route.query.page;
            if (Utils.isEmptyStr(_page)) {
                _page = this.page;
            }

            DMOSManagementService.listDMOS(_page)
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status == 200 && response.data.rows.length > 0) {
                        this.lists = response.data.rows;
                        this.lastPage = response.data.last_page;
                        this.page = response.data.current_page;
                    } else {
                        this.lists = null;
                        this.lastPage = 0;
                        this.page = 1;
                    }
                    this.loading = false;
                }).catch(error => {
                    this.loading = false;
                });

            return false;
        },

        selectDMOS: function selectDMOS (event) {
            event.preventDefault();

            let _ids = [];
            $.each(this.$refs.selectDMOS, function (key, elm) {
                if (elm.checked) {
                    _ids.push(elm.value);
                }
            });

            if (_ids.length == 1) {
                this.deleteObj.ids = _ids;
                this.editObj.ids = _ids;

                let id = _ids[0];
                let _this = this;

                $.each(this.lists, function (key, value) {
                    if (value.id == id) {
                        _this.dmosObj.connection = value.connection;
                        _this.dmosObj.loginId = value.login_id;
                        _this.dmosObj.loginPw = value.login_pw;
                        _this.dmosObj.start = value.start;
                        _this.dmosObj.end = value.end;
                        _this.dmosObj.new_accounting_flag = value.new_accounting_flag;
                        return false;
                    }
                });
            } else {
                this.deleteObj.ids = [];
                this.editObj.ids = [];
                this.dmosObj = {
                    connection: "",
                    loginId: "",
                    loginPw: "",
                    start: "",
                    end: "",
                    new_accounting_flag: false,
                };
            }

            return false;
        },

        selectAllDMOS: function selectAllDMOS (event) {
            event.preventDefault();
            let _ids = [];

            if (event.target.checked) {
                $.each(this.$refs.selectDMOS, function (key, elm) {
                    elm.checked = true;
                    _ids.push(elm.value);
                });
            } else {
                $.each(this.$refs.selectDMOS, function (key, elm) {
                    elm.checked = false;
                });
                _ids = [];
            }

            this.deleteObj.ids = _ids;
            this.editObj.ids = _ids;

            return false;
        },

        unSlectAllDMOS: function unSlectAllDMOS () {
            if (!Utils.isEmptyArr(this.$refs.selectDMOS)) {
                $.each(this.$refs.selectDMOS, function (key, elm) {
                    elm.checked = false;
                });
            }

            // this.$refs.selectAllDMOS.checked = false;
            this.deleteObj.ids = [];
            this.editObj.ids = [];
        },

        resetData: function resetData () {
            this.loading = false;
            this.page = 1;
            this.lastPage = 0;
            this.lists = null;
            this.unSlectAllDMOS();
        },

        requestPagination: function requestPagination (pageNum) {
            this.resetData();
            this.page = pageNum;
            this.fetchData();
            return false;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/admin/DMOSManagement/List.vue